import React from "react";
import Rounded from "./Rounded";
import { useAnimation, motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const customers = [
  "PT Growth Java Industry",
  "PT Citra Lampia Mandiri",
  "PT Century Metalindo",
  "PT Virema Impex",
  "PT PLN Batubara Niaga",
  "PT Daerah Batubara Selatan",
  "PT Aluna Kusumah Lestari",
  "PT Energy Metal Indonesia",
  "PT RMK Energy",
  "PT Bara Menara Karya",
  "PT Asia Global Mandiri",
  "PT Baraanugerah Aneka Tritunggal",
];

export default function Customers() {
  const control = useAnimation();
  const [ref, inView] = useInView();

  const variantBuild = (i) => {
    return {
      visible: {
        opacity: 1,
        y: 0,
        transition: { delay: 0.3 * i, duration: 0.5 },
      },
      hidden: { opacity: 0, y: 100 },
    };
  };

  React.useEffect(() => {
    if (inView) {
      control.start("visible");
    } else {
      control.start("hidden");
    }
  }, [control, inView]);
  return (
    <div className="flex flex-col items-center gap-8 py-16 sm:py-44 relative" ref={ref}>
      <img
        className="w-full h-full object-cover absolute inset-0 filter brightness-50 opacity-30 -z-10"
        src="images/BgAboutUs.png"
        alt="About Us"
      />
      <motion.h2
        className="text-3xl font-bold text-default"
        animate={control}
        initial="hidden"
        variants={variantBuild(0)}
      >
        Our Customers
      </motion.h2>
      <motion.p
        animate={control}
        initial="hidden"
        variants={variantBuild(1)}
        className="text-default font-bold tracking-wider text-center px-2"
      >
        We work together with smelter companies, mining companies and traders across Indonesia.
      </motion.p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 sm:gap-8 gap-4 place-items-center">
        {customers.map((customer, index) => (
          <motion.div key={customer} animate={control} initial="hidden" variants={variantBuild(index + 2)}>
            <Rounded>{customer}</Rounded>
          </motion.div>
        ))}
      </div>
      <motion.div className="-mt-4 sm:mt-0" animate={control} initial="hidden" variants={variantBuild(14)}>
        <Rounded>PT Karunia Energi Indonesia</Rounded>
      </motion.div>
    </div>
  );
}
